import { useRef } from 'react';
import {
  DataGridPro,
  DataGridProProps,
  GridColumnOrderChangeParams,
  MuiEvent,
  GridCallbackDetails,
  enUS,
  ruRU,
} from '@mui/x-data-grid-pro';
import { pageSizeOptions } from './constants';
import {
  CircularProgress,
  CustomColumnMenu,
  CustomPagination,
  NoDataOverlay,
} from './slots';

let locale = localStorage.getItem('lang') || 'en';
if (locale === 'en') locale = 'en-US';
if (locale === 'ru') locale = 'ru-RU';

const dataGridLocales = locale === 'en-US' ? enUS : ruRU;

export const DataGridTable = (props: DataGridProProps) => {
  const ref = useRef(null);

  const {
    rows,
    columns,
    paginationMode,
    rowSelectionModel,
    onColumnOrderChange,
    pagination = true,
    sx = {},
    ...rest
  } = props;

  // TODO: replace any
  const handleColumnOrderChange = (
    params: GridColumnOrderChangeParams,
    event: MuiEvent<any>,
    details: GridCallbackDetails & { api?: any }
  ) => {
    if (onColumnOrderChange instanceof Function) {
      const [column] = details.api.getAllColumns();
      if (column.type === 'checkboxSelection') {
        onColumnOrderChange(
          {
            ...params,
            oldIndex: params.oldIndex - 1,
            targetIndex: params.targetIndex - 1,
          },
          { defaultMuiPrevented: false },
          details
        );
      } else {
        onColumnOrderChange(params, { defaultMuiPrevented: false }, details);
      }
    }
  };

  return (
    <DataGridPro
      ref={ref}
      rows={rows}
      columns={columns}
      pagination={pagination}
      slots={{
        columnMenu: CustomColumnMenu,
        loadingOverlay: CircularProgress,
        pagination: CustomPagination,
        noResultsOverlay: NoDataOverlay,
        noRowsOverlay: NoDataOverlay,
      }}
      // на случай если в rowSelectionModel будет null
      rowSelectionModel={rowSelectionModel ?? undefined}
      pageSizeOptions={pageSizeOptions}
      onColumnOrderChange={handleColumnOrderChange}
      paginationMode={paginationMode ?? 'server'}
      sx={{ ...sx, flex: '1 1 0px' }}
      localeText={dataGridLocales.components.MuiDataGrid.defaultProps.localeText}
      {...rest}
    />
  );
};
